import { isThisSecond } from 'date-fns';
import React, { Component, useEffect, useState } from 'react';
import ModalAlert from '../../components/ModalAlert';
import { getAppCfg, getCurrency, setPaymentRecuring, setTopupInfo } from '../../utils/common';
import t from '../../utils/translateUtil';
import { isValidEmail, newGUID } from '../../utils/util';
import crmservices from '../../wsclient/crmservices';
import { cignalservices } from '../../wsclient/crmservices/cignalservices';
import { dataUtil } from '../../wsclient/crmservices/dataUtil';
import AddCard from '../order-cards/AddCard';
import PaymentForm from './PaymentForm';
import TopupWalletView from './TopupWalletView';
import AutomateWalletView from './AutomateWalletView';
import { portalCfg, paths } from '../../../portal.router.config';
import { connection, domainName } from '../../../portal.config';
import Cookies from 'js-cookie';
import { payment } from '../../wsclient/crmservices/payment';
export default function TopupWalletController(props) {

    const [showLoading, onShowLoading] = useState(false);
    const [wallet, setWallet] = useState(null);
    const [primary_card, setPrimaryCard] = useState(null);
    const [cards, setCards] = useState([]);
    const [cardSelect, setCardSelect] = useState({});
    const [amount, setAmount] = useState(null);
    const [error, setError] = useState({});
    const [validation, setValidation] = useState(undefined);
    const [showAddCard, setShowAddCard] = useState(false);
    const [html_add_card_content, setHtmlAddCardConten] = useState(null);
    const [showPaymentForm, setShowPaymentForm] = useState(false);
    const [paymentFormData, setPaymentFormData] = useState(null);
    const [showAutomateWallet, setShowAutomateWallet] = useState(false);
    const [automateInfo, setAutomateInfo] = useState({});
    const [contact, setContact] = useState({});
    const [integration, setIntegration] = useState(null);
    const currency = getCurrency();

    useEffect(() => {
        init();
    }, [])
    const init = async () => {
        onShowLoading(true);
        onLoadCards();
        await onLoadWallet();
        if (domainName == 'cignal') {
            onLoadContact();
        }
        await getIntegrations();
        onShowLoading(false);
    }

    const onLoadContact = async () => {
        try {
            var result = await crmservices.contacts.getContact();
            if (result.code === 'OK') {
                setContact(result.data)
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }

    const onLoadCards = async () => {
        try {
            var result = await crmservices.contacts.getListPaymentMethods();
            //console.log('onLoadCards  result=', result)
            if (result.code == 'OK') {
                var cards = result.data && result.data.content ? result.data.content : [];
                if (cards.length > 0) {
                    setCards(cards)
                    var cardPrimary = cards.filter(card => {
                        return card.is_primary
                    })
                    if (cardPrimary && cardPrimary.length > 0) {
                        setCardSelect(cardPrimary[0])
                    } else {
                        setCardSelect(cards[0])
                    }
                }
            }
        } catch (error) {
            console.log("load my order exception:", error);
        }
    }
    const onLoadWallet = async () => {
        try {
            var result = await crmservices.account.getWalletInfo();
            console.log("AAAAAA load wallet:", result);
            if (result.code === 'OK') {
                setWallet(result.data.wallet);
            }
        } catch (error) {
            console.log("load contact error:", error);
        }
    }
    const onPayMayaTopup = async (values) => {
        onShowLoading(true);
        try {
            let timestamp = new Date().getTime();
            let body = {
                customer_id: contact.code,
                first_name: contact.first_name,
                last_name: contact.last_name,
                amount: values.amount,
                redirect_url_success: window.location.origin + portalCfg.basename  + paths.paymaya_redirect_url_success + "?timestamp=" + timestamp,
                redirect_url_failure: window.location.origin + portalCfg.basename  + paths.paymaya_redirect_url_failure + "?timestamp=" + timestamp,
                redirect_url_cancel: window.location.origin + portalCfg.basename  + paths.paymaya_redirect_url_dropout + "?timestamp=" + timestamp,
            }
            const result = await cignalservices.initiateTopUp(body);
            console.log("result:", result);
            if (result.code == 'OK') {
                onShowLoading(false);
                Cookies.set("paymaya_" + timestamp, result.data.request_reference_number, { expires: 10000 });
                window.location.href = result.data.paymaya_redirect_url;
            } else {
                showAlert(t('EXCEPTION_PROCESS'));
            }
        } catch (ex) {
            console.log("onPayMayaTopup ex:", ex)
            showAlert(t('EXCEPTION_PROCESS'));
        }
    }
    const on3DSecure = async (values) => {
        //topup 3D check
        onShowLoading(true);
        setPaymentFormData(null);
        setShowPaymentForm(false);
        var token = newGUID();
        let responseURL = window.location.origin + portalCfg.basename + '/process_topup/' + token;

        var paymentFormResult = await crmservices.account.createPaymentFormTopup({ topup_amount: Number(amount), payment_method_id: cardSelect.id, redirect_url: responseURL });
        if (paymentFormResult.code == 'OK') {
            let body = {
                token: token,
                wallet_id: wallet.id,
                amount: Number(amount),
                payment_method_id: cardSelect.id,
            }
            console.log('on3DSecure body==', body)
            setTopupInfo(body)
            setPaymentFormData(paymentFormResult.data);
            setShowPaymentForm(true);
        } else {
            showAlert(t('EXCEPTION_PROCESS'));
        }
        onShowLoading(false);
    }
    const onTopupOld = async (values) => {
        let date = (new Date()) / 1000;
        let body = {
            wallet_id: wallet.id,
            topup_date: date.toFixed(0),
            amount: Number(amount),
            payment_method_id: cardSelect.id,
        }
        try {
            onShowLoading(true);
            let result = await crmservices.account.topUpWallet(body);
            if (result.code == 'OK') {
                await onLoadWallet();
                showAlert(t('TOPUP_SUCCESS'))
                setAmount('');
            }
            else if (result.code == 'PAYMENT_GATEWAY_EXCEPTION') {
                showAlert(t('TOPUP_FAILED'))
            }
            else {
                showAlert(t('EXCEPTION_PROCESS'))
            }
        }
        catch (e) {
            console.log(' Topup Error: ', e)
            showAlert(t('EXCEPTION_PROCESS'))
        }
    }
    const onShowAddCard = async () => {
        if (!showAddCard) {
            onShowLoading(true);
            setShowAddCard(!showAddCard);
            try {
                var result = await crmservices.contacts.createFormToAddCard();
                // console.log(' onPrepareForm result===', result)
                if (result.code == 'OK') {
                    //window.document.write(result.data);
                    setHtmlAddCardConten(result.data);
                }
            } catch (error) {
                console.log("on create form to add card exception:", error);
            }
            onShowLoading(false);
        }
        else {
            setShowAddCard(!showAddCard)
            onShowLoading(true);
            await onLoadCards();
            onShowLoading(false);
        }

    }
    const showAlert = (message) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
        });
    }
    const onCloseAlert = () => {
        onShowLoading(false);
        setError({
            showAlert: false,
            message: '',
        });
    }
    const onShowPaymentForm = async () => {
        if (showPaymentForm) {
            onShowLoading(true);
            setShowPaymentForm(false);
            await onLoadWallet();
            onShowLoading(false);
        }
        else {
            setShowPaymentForm(true);
        }

    }
    const onChangeInput = (value) => {
        //console.log('onChangeInput====', value)
        setAmount(value);
    }
    const onChangeInputAutoWallet = (target, value) => {
        //console.log('onChangeInputAutoWallet====', value)
        //console.log('onChangeInputAutoWallet====', target)
        setAutomateInfo(prevState => ({
            ...prevState,
            [target]: value
        }))
    }
    const onAutomateWallet = async () => {

    }
    const onTopup = async () => {
        onShowLoading(true)
        try {
            console.log("AAAA onTopup cardSelected: ", cardSelect)
            console.log("AAAA onTopup wallet: ", wallet)
            let businessName = document._portalConfig.domainCustomer ? document._portalConfig.domainCustomer : 'airlink';
            if(businessName === 'airlink-al-wired') businessName = 'airlinkaw';

            let token = newGUID();
            let redirectUrl = `${window.location.origin}${paths.new_process_topup}?token=${token}`
            if (cardSelect && cardSelect.card && cardSelect.card.gateway_token && cardSelect.card.gateway_token.length > 0) {
                let gateway_token = cardSelect.card.gateway_token[0];
                if (gateway_token.integration && gateway_token.integration.id == integration.id) {
                    //Solid gate
                    setTopupInfo({
                        is_recurring: false,
                        amount: amount,
                        token: token,
                        from: 'topup',
                        type: cardSelect && cardSelect.payment_method_type,
                        payment_method_id: cardSelect && cardSelect.id,
                    });
                    let result = await payment.getPaymentForm({
                        integration_id: integration && integration.id,
                        redirect_url: redirectUrl,
                        amount: Number(amount),
                        currency_code: wallet.currency_code,
                        device_type: 'BROWSER',
                        type: 'TOP_UP',
                        payment_method_id: cardSelect.id,
                        header_accept: '*/*',
                        header_accept_language: navigator.language,
                        browser_color_depth: window.screen.colorDepth,
                        browser_screen_height: window.screen.availHeight,
                        browser_screen_width: window.screen.availWidth,
                        browser_java_enabled: false,
                        time_zone_offset: -(new Date()).getTimezoneOffset(),
                        user_agent: navigator.userAgent
                    })
                    if (result.code == 'OK') {                                   
                        let data = result.data ? JSON.parse(result.data) : null;
                        if (data && data.form_url) window.location.href = data.form_url;
                    }
                    else {
                        let error = result.data && result.data.message ? result.data.message : 'Have an error for topup'
                        if (result.data && result.data.parameters) error += ' ' + result.data.parameters.join(',');
                        showAlert(error);
                    }
                }
            }
        } catch (error) {
            console.log("AAAA onTopup error: ", error)
        }
        onShowLoading(false)
    }
    const getIntegrations = async () => {
        if (connection.crmConfig.isOpenStripe) {
            setIntegration({ id: connection.crmConfig.stripeIntegration })
            return;
        }
        try {
            let portalConfig = getAppCfg();
            let result = await payment.getIntegrations({
                connector: 'SOLIDGATE'
            }, portalConfig.id);
            console.log("AAAA getIntegrations result: ", result)
            if (result.code == 'OK') {
                if (result.data && result.data.content && result.data.content.length > 0) setIntegration(result.data.content[0])
            }
        } catch (error) {
            console.log("AAAA getIntegrations error: ", error)
        }
    }

    return (
        <div>
            <TopupWalletView
                showLoading={showLoading}
                open={props.open}
                currency={currency}
                onClose={props.onClose}
                onTopup={onTopup}
                cards={cards.sort(dataUtil.sortByCardPrimary)}
                cardSelect={cardSelect}
                wallet={wallet}
                onChangeInput={onChangeInput}
                amount={amount}
                setCardSelect={setCardSelect}
                onShowAddCard={onShowAddCard}
                on3DSecure={on3DSecure}
                onPayMayaTopup={onPayMayaTopup}
                setShowAutomateWallet={setShowAutomateWallet} />
            {showAddCard && <AddCard
                open={showAddCard}
                onClose={onShowAddCard}
                html_add_card_content={html_add_card_content} />}
            {showPaymentForm && <PaymentForm
                open={showPaymentForm}
                onClose={onShowPaymentForm}
                paymentFormData={paymentFormData}
            />}
            {showAutomateWallet && <AutomateWalletView
                open={showAutomateWallet}
                automateInfo={automateInfo}
                onAutomateWallet={onAutomateWallet}
                onChangeInputAutoWallet={onChangeInputAutoWallet}
                onClose={() => setShowAutomateWallet(false)} />}
            <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
            />
        </div>
    );
}
